import type { AudioTrackLength } from '../types/audio-length.js';

/**
 * Create AudioTrackLength from legacy metadata values
 * This provides a clean conversion from the old confusing terminology
 */
export function createTrackLength(
  originalSamples: number,
  decodedLength: number,
  encoderDelay: number,
  endPadding: number
): AudioTrackLength {
  return {
    syncLength: originalSamples, // Use original for sync
    playbackLength: decodedLength, // Use decoded for reading
    metadata: {
      encoderDelay,
      endPadding,
      fileLength: originalSamples + encoderDelay + endPadding
    }
  };
}

/**
 * Convert legacy GaplessMetadata to new AudioTrackLength format
 */
export function convertLegacyMetadata(
  metadata: { encoderDelay: number; endPadding: number; originalSamples: number },
  decodedLength: number
): AudioTrackLength {
  return createTrackLength(
    metadata.originalSamples,
    decodedLength,
    metadata.encoderDelay,
    metadata.endPadding
  );
}

/**
 * Get appropriate length for synchronization logic
 */
export function getSyncLength(trackLength: AudioTrackLength): number {
  return trackLength.syncLength;
}

/**
 * Get appropriate length for audio reading logic
 */
export function getPlaybackLength(trackLength: AudioTrackLength): number {
  return trackLength.playbackLength;
}
